import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'axios';
// Components
import Login from './components/Login';
import SearchByCP from './components/SearchByCP';
import SuiviDashboard from './components/SuiviDashboard';
import MesObjectifs from './components/MesObjectifs';
import Boitage from './components/Boitage';
import AdminCommerciaux from './components/AdminCommerciaux';
import Layout from './components/Layout';
// API
import { api, setAuthToken, API_URL } from './utils/api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setAuthToken(token);
      fetchUser();
    } else {
      trySso();
    }
  }, []);

  // Session unique : si le Cockpit 2A Immo a posé son cookie (sso_2a), on
  // l'échange contre un token ProspectScore sans redemander de mot de passe.
  // axios brut (pas l'instance `api`) : son intercepteur 401 rechargerait la page.
  const trySso = async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/sso`);
      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      setAuthToken(access_token);
      const me = await api.get('/auth/me');
      setUser(me.data);
    } catch (error) {
      // Pas de session Cockpit : on affiche la page de connexion
    } finally {
      setLoading(false);
    }
  };

  const fetchUser = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur auth:', error);
      localStorage.removeItem('token');
      setAuthToken(null);
      await trySso();
    }
  };

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    setAuthToken(token);
    setUser(userData);
  };

  const handleLogout = async () => {
    localStorage.removeItem('token');
    setAuthToken(null);
    setUser(null);
    // Ferme aussi la session partagée (Cockpit, 2A Social), sinon le SSO
    // rouvrirait la session au prochain chargement.
    try { await axios.post(`${API_URL}/auth/sso/logout`); } catch (e) { /* SSO inactif */ }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        Chargement...
      </Box>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Layout user={user} onLogout={handleLogout}>
      <Routes>
        <Route path="/search" element={<SearchByCP />} />
        <Route path="/suivi" element={<SuiviDashboard />} />
        <Route path="/objectifs" element={<MesObjectifs user={user} />} />
        <Route path="/boitage" element={<Boitage user={user} />} />
        {user.role === 'admin' && <Route path="/admin/commerciaux" element={<AdminCommerciaux user={user} />} />}
        <Route path="*" element={<Navigate to="/search" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
